import { useState } from "react"

import { useTranslation } from "react-i18next"

import { Upload } from "@/components/icons"
import { buttonVariants } from "@/components/ui/button-variants"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

export function DemoFileUpload() {
  const { t } = useTranslation()
  const [isAnimating, setIsAnimating] = useState(false)

  const handleClick = () => {
    setIsAnimating(true)
    setTimeout(() => setIsAnimating(false), 600)
  }

  return (
    <div className="flex items-center gap-2">
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className={cn(
              buttonVariants({ size: "icon", variant: "icon" }),
              "size-7 min-w-7 transition-transform",
              isAnimating && "scale-110 animate-pulse"
            )}
            onClick={handleClick}
          >
            <Upload className="size-5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-[250px]" side="bottom" sideOffset={5}>
          <p>{t("questioninput.upload_file")}</p>
        </TooltipContent>
      </Tooltip>
      <span className="text-muted-foreground text-sm">{t("questioninput.upload_file")}</span>
    </div>
  )
}
